import { QueryDocumentSnapshot } from "firebase/firestore";
import { DocumentData, DocumentSnapshot, Timestamp } from "shared/api/firebase";
import { BrandLanguage, BrandLanguageDBT } from "../type";

type LanguageDataT = Omit<BrandLanguageDBT, "id">;

export class LanguageDB {
  id: string;
  displayName: string;
  code: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  constructor(
    language: QueryDocumentSnapshot | DocumentSnapshot<DocumentData>,
  ) {
    if (!language.exists()) {
      throw new Error(`Language ${language.id} does not exist`);
    }

    const data = language.data() as LanguageDataT;

    this.id = language.id;
    this.displayName = data.displayName;
    this.code = data.code;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }

  toBrandLanguage(): BrandLanguage {
    return {
      id: this.id,
      displayName: this.displayName,
      code: this.code,
      createdAt: this.createdAt.toDate(),
      updatedAt: this.updatedAt.toDate(),
    };
  }
}
